import '.ax{position:relative;}.ssr-plugin'
import '.iu{width:64px;}.ssr-plugin'
import '.iv{height:64px;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.bf{position:absolute;}.ssr-plugin'
import '.iw{bottom:-4px;}.ssr-plugin'
import '.i2{right:-4px;}.ssr-plugin'
import '.g8{border-radius:50%;}.ssr-plugin'
import '.ix{border:2px solid var(--palette-white);}.ssr-plugin'
import '.as{overflow:hidden;}.ssr-plugin'
import '.iy{width:32px;}.ssr-plugin'
import '.iz{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ax iu iv ag"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bf iw i2 g8 ix as iy iz"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
